import styled from 'styled-components';
import { DesktopFooter as _DesktopFooter } from '@/components/Footer';

export const Page = styled.div`
  min-height: 100vh;
  background-color: ${({ theme }) => theme.palette.secondary.background};
`;

export const Main = styled.main`
  display: grid;
  grid-template-columns: 240px minmax(0, 1fr);
  gap: 30px;
  width: min(100%, 1280px);
  margin: 0 auto;
  padding: 40px 80px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
    padding: 0 0 10px;
    background-color: ${({ theme }) => theme.palette.secondary.background};
  }
`;

export const Sidebar = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 25px;
  align-self: start;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`;

export const Content = styled.div`
  align-self: start;
  padding: 30px;
  border-radius: 21px;
  background-color: ${({ theme }) => theme.palette.primary.background};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-top: 10px;
    padding: 20px 15px;
  }
`;

export const DesktopFooter = styled(_DesktopFooter)`
  padding: 40px calc((100% - 1280px) / 2 + 80px) 15px;

  @media (max-width: 1300px) and (min-width: 950px) {
    padding: 40px 80px 15px;
  }
`;
